import { useEffect, useState } from 'react';
import { INSTALLER_ERRORS } from '../errors';
import { fetchTranslations } from '../services/fetch-translations';
import { fetchIdentityUserToken } from '../services/fetch-identity-user-token';
import { loadExperiments } from '../services/experiments';
export const useInstallerPrerequisites = _ref => {
  let {
    essentials: {
      httpClient,
      i18n
    },
    topology,
    panoramaClient,
    appId
  } = _ref;
  const [prerequisitesState, setPrerequisitesState] = useState({
    isDetermined: false
  });
  useEffect(() => {
    (async () => {
      const errors = [];
      const prerequisitesTransaction = panoramaClient == null ? void 0 : panoramaClient.transaction('fetch-prerequisites');
      prerequisitesTransaction == null || prerequisitesTransaction.start({
        appId
      });
      await Promise.all([loadExperiments(errors), fetchIdentityUserToken(httpClient, errors), fetchTranslations(httpClient, i18n, topology, errors)]).finally(() => {
        prerequisitesTransaction == null || prerequisitesTransaction.finish({
          appId
        });
      });
      let prerequisiteError;
      if (errors.length) {
        prerequisiteError = {
          error: new Error(JSON.stringify(errors)),
          ...INSTALLER_ERRORS.FAILED_TO_LOAD_PREREQUISITES
        };
      }
      setPrerequisitesState({
        isDetermined: true,
        error: prerequisiteError
      });
    })();
  }, []);
  return {
    prerequisitesState
  };
};
//# sourceMappingURL=useInstallerPrerequisites.js.map